import { render, staticRenderFns } from "./LayoutNews.vue?vue&type=template&id=1c0c6780&scoped=true"
import script from "./LayoutNews.vue?vue&type=script&lang=js"
export * from "./LayoutNews.vue?vue&type=script&lang=js"
import style0 from "./LayoutNews.vue?vue&type=style&index=0&id=1c0c6780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c6780",
  null
  
)

export default component.exports